import React from 'react';
import PropTypes from 'prop-types';
import PanelScreenComponent from "./ScreenComponents/PanelScreenComponent";
import JsonScreenHoc from "../../../HocHelpers/JsonScreenHoc";
import RenderComponents from "./ScreenComponents/RenderComponents";
import './screen.css'
import Footer from "../../Footer";

const Screen = (props) => {
    const {containerArrayPath, basePath, screen, footerSource} = props;

    return (
        <div className={'printPage'} ref={props.screenRef}
             style={{height: '100%'}}>
            {(screen.children || []).map((item, index) => {
                    return (
                        <React.Fragment key={item.id}>
                            {item.type === 'panel' ? (
                                <PanelScreenComponent
                                    key={item.id}
                                    panel={item}
                                    containerArrayPath={containerArrayPath}
                                    basePath={basePath}
                                />
                            ) : (
                                <RenderComponents
                                    key={item.id}
                                    element={item}
                                    containerArrayPath={containerArrayPath}
                                    basePath={basePath}
                                />
                            )}
                        </React.Fragment>
                    )
                })}
            {
                footerSource && (
                    <Footer
                        component={footerSource}
                    />
                )
            }
        </div>
    );
};
export default JsonScreenHoc(Screen);

Screen.propTypes = {
    screen: PropTypes.object,
    containerArrayPath: PropTypes.string,
    basePath: PropTypes.string,
    screenValues: PropTypes.array
};